var scope_0 = require('/usr/src/app/www/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/810b14a6cdad403b6ddddb665e105748.js').default;
var scope_1 = require('/usr/src/app/www/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    